import { Divider, VStack } from "@chakra-ui/react"
import { Children, Fragment, ReactNode, isValidElement } from "react"

type CardLinksProps = {
  children: ReactNode
}

// Renders a list of CardLinks separateed by Dividers that conditionally hide
// when the group is hovered over.
function CardLinks({ children }: CardLinksProps) {
  const validChildren = Children.toArray(children).filter(isValidElement)
  return (
    // NOTE: idea is to hide the Divider when an adjacent item is hovered,
    // but current solution targets parent hover, so all Dividers will hide when
    // parent is hovered. This seems to be OK, even fine, but will need to refactor if not.
    // This idea maybe moot if we don't round the CardLink borders.
    <VStack className="group" w="100%" spacing={0} align="center">
      {validChildren.map((child, i) => (
        <Fragment key={i}>
          {child}
          {i < validChildren.length - 1 && (
            <Divider _groupHover={{ visibility: "hidden" }} />
          )}
        </Fragment>
      ))}
    </VStack>
  )
}

export default CardLinks
